import moment from "moment/moment";
import ApiClient from "../../backends/ApiClient";
import { IFallbackData } from "../../utils/SchoolBlocksUtilities";

interface SchoolFeedItemListQuery {
  organization_id?: string;
  is_event: boolean;
  created_at__gte: string;
  created_at__lte: string;
  page_size: number;
  ordering: string;
  expand: string[];
  published?: boolean;
}

export const currentRangeUrlQueryFormat = "YYYY-MM-DD";

export const eventsQuery = (gte, lt, baseFilterParams?) => {
  return {
    is_event: true,
    created_at__gte: gte,
    created_at__lt: lt,
    page_size: 200,
    published: true,
    expand: ["organization"],
    ordering: "created_at",
    ...baseFilterParams,
  };
};

export const getEventsForRange = async (
  pathQueryParams,
  urlQuery,
  start?: string,
  end?: string,
): Promise<IFallbackData> => {
  let gte;
  let lte;

  if (start && end) {
    gte = start;
    lte = end;
  } else {
    gte = moment().startOf("month").format(currentRangeUrlQueryFormat);
    lte = moment()
      .add(1, "months")
      .startOf("month")
      .format(currentRangeUrlQueryFormat);
  }

  return new Promise((res) => {
    ApiClient().then((client) => {
      const q: SchoolFeedItemListQuery = eventsQuery(gte, lte, pathQueryParams);
      // query has fields (organization_id, page_size, etc.) beyond what the
      // generated schema documents for these endpoints, so it's passed through untyped
      const query = { ...q, expand: q.expand.join(",") } as never;

      const resultPromise = urlQuery.orgId
        ? (client.GET("/organizations/{organization_pk}/schoolfeed_items/", {
            params: {
              path: { organization_pk: urlQuery.orgId },
              query,
            },
          }) as any)
        : (client.GET("/schoolfeed_items/", { params: { query } }) as any);

      resultPromise.then((result) => {
        res({
          contentItems: result.data,
          total: result.meta.total,
        });
      });
    });
  });
};
